import type { OpportunitySource, OpportunityStatus } from "./opportunityTypes";

/**
 * Funnel order. `NotEligible` and `Expired` are deliberate terminal states rather
 * than deletions: knowing *why* we were blocked, and how often a deadline passed
 * us by, is the point of tracking this at all.
 */
export const STATUS_ORDER: OpportunityStatus[] = [
  "Detected",
  "Evaluating",
  "Eligible",
  "Preparing",
  "Submitted",
  "UnderReview",
  "Won",
  "NotEligible",
  "Lost",
  "Expired",
];

export const STATUS_LABEL: Record<OpportunityStatus, string> = {
  Detected: "Detected",
  Evaluating: "Evaluating",
  Eligible: "Eligible",
  NotEligible: "Not eligible",
  Preparing: "Preparing",
  Submitted: "Submitted",
  UnderReview: "Under review",
  Won: "Won",
  Lost: "Lost",
  Expired: "Expired",
};

/** Tailwind classes for the column header accent. */
export const STATUS_ACCENT: Record<OpportunityStatus, string> = {
  Detected: "bg-slate-400",
  Evaluating: "bg-sky-500",
  Eligible: "bg-emerald-500",
  NotEligible: "bg-zinc-400",
  Preparing: "bg-amber-500",
  Submitted: "bg-indigo-500",
  UnderReview: "bg-violet-500",
  Won: "bg-green-600",
  Lost: "bg-rose-500",
  Expired: "bg-red-600",
};

export const SOURCE_LABEL: Record<OpportunitySource, string> = {
  SECOP: "SECOP II",
  Convocatoria: "Convocatoria",
  InnovationCall: "Innovation call",
  DirectAward: "Direct award",
  PartnerLead: "Partner lead",
  Manual: "Manual",
};

export const SOURCE_BADGE: Record<OpportunitySource, string> = {
  SECOP: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  Convocatoria: "bg-sky-100 text-sky-700 dark:bg-sky-950 dark:text-sky-300",
  InnovationCall: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
  DirectAward: "bg-amber-100 text-amber-700 dark:bg-amber-950 dark:text-amber-300",
  PartnerLead: "bg-violet-100 text-violet-700 dark:bg-violet-950 dark:text-violet-300",
  Manual: "bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-300",
};

/** Statuses where a looming deadline still matters. Past these, urgency is noise. */
export const ACTIONABLE_STATUSES: OpportunityStatus[] = [
  "Detected",
  "Evaluating",
  "Eligible",
  "Preparing",
];

export const TERMINAL_STATUSES: OpportunityStatus[] = [
  "Won",
  "Lost",
  "Expired",
  "NotEligible",
];

export const URGENT_DAYS = 14;
